const roleReducer = (state = {}, action) => {
    switch (action.type) {
        default:
            return state
    }
};

export default roleReducer;